import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class OngoingInfo extends Component {

  render() {

    let CustomClass = this.props.customClass ? this.props.customClass : ''

    let publicUrl = process.env.PUBLIC_URL + '/'

    return <div className={"ltn__apartments-plan-area pt-115--- pb-70 " + CustomClass}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title-area ltn__section-title-2--- text-center">
              {/* <h6 className="section-subtitle section-subtitle-2--- ltn__secondary-color">Apartment Sketch</h6> */}
              <h1 className="section-title">Ongoing Properties</h1>
            </div>
            <div className="ltn__tab-menu ltn__tab-menu-3 ltn__tab-menu-top-right-- text-uppercase--- text-center">
              <div className="nav">
                <a data-bs-toggle="tab" href="#liton_tab_3_1">Manimangalam</a>
                <a className="active show" data-bs-toggle="tab" href="#liton_tab_3_2">Tambaram</a>
                <a data-bs-toggle="tab" href="#liton_tab_3_3">Guduvancheri</a>
              </div>
            </div>
            <div className="tab-content">
              <div className="tab-pane fade" id="liton_tab_3_1">
                <div className="ltn__apartments-tab-content-inner">
                  <div className="row">
                    <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/ongoing"><img src={publicUrl + "assets/img/projects/Zion Garden/img2.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot: 38</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Padapai</Link></h6>
                            <h4><Link to="/ongoing">Zion Garden</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/ongoing"><img src={publicUrl + "assets/img/projects/K.R Garden/img2.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of plots: 162</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Chetpattu</Link></h6>
                            <h4><Link to="/ongoing">K.R Garden</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/"><img src={publicUrl + "assets/img/projects/GlobelCity/img1.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>9 Properties</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Oragadam,Vadakupattu</Link></h6>
                            <h4><Link to="/ongoing">Global City</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/"><img src={publicUrl + "assets/img/projects/Hari Nagar/img1.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of Plots: 10</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Kolathur</Link></h6>
                            <h4><Link to="/ongoing">Hari Nagar</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade active show" id="liton_tab_3_2">
                <div className="ltn__product-tab-content-inner">
                  <div className="row">
                    <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/ongoing"><img src={publicUrl + "assets/img/projects/Zion Garden/img2.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot: 38</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Padapai</Link></h6>
                            <h4><Link to="/ongoing">Zion Garden</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/ongoing"><img src={publicUrl + "assets/img/projects/K.R Garden/img2.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of plots: 162</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Chetpattu</Link></h6>
                            <h4><Link to="/ongoing">K.R Garden</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/"><img src={publicUrl + "assets/img/projects/GlobelCity/img1.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>9 Properties</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Oragadam,Vadakupattu</Link></h6>
                            <h4><Link to="/ongoing">Global City</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/"><img src={publicUrl + "assets/img/projects/Hari Nagar/img1.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of Plots: 10</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Kolathur</Link></h6>
                            <h4><Link to="/ongoing">Hari Nagar</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab-pane fade" id="liton_tab_3_3">
                <div className="ltn__product-tab-content-inner">
                  <div className="row">
                    <div className="row ltn__search-by-place-slider-1-active slick-arrow-1 go-top">
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/ongoing"><img src={publicUrl + "assets/img/projects/Zion Garden/img2.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of plot: 38</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Padapai</Link></h6>
                            <h4><Link to="/ongoing">Zion Garden</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/ongoing"><img src={publicUrl + "assets/img/projects/K.R Garden/img2.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of plots: 162</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Chetpattu</Link></h6>
                            <h4><Link to="/ongoing">K.R Garden</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/"><img src={publicUrl + "assets/img/projects/GlobelCity/img1.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>9 Properties</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Oragadam,Vadakupattu</Link></h6>
                            <h4><Link to="/ongoing">Global City</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="ltn__search-by-place-item">
                          <div className="search-by-place-img">
                            <Link to="/"><img src={publicUrl + "assets/img/projects/Hari Nagar/img1.jpg"} alt="#" /></Link>
                            <div className="search-by-place-badge">
                              <ul>
                                <li>No of Plots: 10</li>
                              </ul>
                            </div>
                          </div>
                          <div className="search-by-place-info">
                            <h6><Link to="/ongoing">Kolathur</Link></h6>
                            <h4><Link to="/ongoing">Hari Nagar</Link></h4>
                            <div className="search-by-place-btn">
                              <Link to="/ongoing">View Property <i className="flaticon-right-arrow" /></Link>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

export default OngoingInfo